<script setup lang="ts">
import type { WrapperProductTileProps } from './WrapperProductTile.props'
import { useWrapperProductTile } from '../composables/useWrapperProductTile'

/**
 * Component props with default values
 *
 * @type {WrapperProductTileProps}
 * @property {string} [id=''] - Optional product identifier
 * @property {string} [data-testid=''] - Optional test identifier
 */
const props = withDefaults(defineProps<WrapperProductTileProps>(), {
  id: '',
  'data-testid': '',
})

/**
 * Destructure methods from useWrapperProductTile composable
 */
const { normalizeProduct, transformToProductCardHorizontal } =
  useWrapperProductTile()

/**
 * Computed property to normalize the product
 *
 * @type {ComputedRef<ProductTileType | undefined>}
 */
const normalizedProduct = computed(() => normalizeProduct(props.product))

/**
 * Computed property to transform product to horizontal card format
 *
 * @type {ComputedRef<ProductCardHorizontal | undefined>}
 */
const transformedProductCardHorizontal = computed(() => {
  if (!normalizedProduct.value) return
  return transformToProductCardHorizontal(normalizedProduct.value)
})
</script>

<template>
  <div class="contents">
    <slot
      v-if="normalizedProduct && transformedProductCardHorizontal"
      :product="normalizedProduct"
      :product-card-horizontal="transformedProductCardHorizontal"
    />
  </div>
</template>
